import dayjs from "dayjs";
import { logTillLifecycle } from "./tillLogoutRelease";
import { logSequenceEvent } from "./sequenceAudit";

// BUG-2582: a till's local data disappeared (KWC 09-Oct KO, 13-Oct CV): the next login could
// only reach Open Till, which the server refused with "Close Till is pending". What removed
// the data could not be proven afterwards, because nothing on the device recorded it.
//
// Two records, both kept in the durable sequenceAuditLog trail (the table support exports
// with the device backup) and sent to CW Browser's till-lifecycle log:
//   - "local-db-recreated": DexieAdapter deleted the database after VersionError /
//     UpgradeError. The marker is written to localStorage before the delete (the table goes
//     with the database) and moved into the new database's trail on the next start.
//   - "till-data-missing": this browser remembers a till (localStorage tillValue) but has no
//     till registration row: the database was emptied while localStorage was kept.
export const DB_RESET_MARKER_KEY = "cwpos_db_reset_marker";

export function markLocalDbReset(err) {
  const marker = { at: dayjs().format("YYYY-MM-DD HH:mm:ss"), name: err?.name || null, message: err?.message || null };
  try {
    localStorage.setItem(DB_RESET_MARKER_KEY, JSON.stringify(marker));
  } catch (e) {
    console.warn("[LocalTillDataLoss] marker write failed", e?.message);
  }
  logTillLifecycle("error", "Local database deleted and recreated", marker);
  return marker;
}

const readTillValue = () => {
  try {
    const raw = localStorage.getItem("tillValue");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// tables: { tillRegistrations, tillEvents, sequenceAuditLog } (Dexie tables).
// Returns the events written (for tests). Never throws.
export async function reportLocalTillDataLoss(tables) {
  const written = [];
  const sink = { sequenceAuditLog: tables?.sequenceAuditLog };
  try {
    const raw = localStorage.getItem(DB_RESET_MARKER_KEY);
    if (raw) {
      let marker = null;
      try {
        marker = JSON.parse(raw);
      } catch {
        marker = { raw };
      }
      logSequenceEvent("local-db-recreated", { resetAt: marker?.at ?? null, errorName: marker?.name ?? null, errorMessage: marker?.message ?? null }, sink);
      logTillLifecycle("error", "Local database was deleted and recreated on the last start", marker);
      localStorage.removeItem(DB_RESET_MARKER_KEY);
      written.push("local-db-recreated");
    }
  } catch (err) {
    console.warn("[LocalTillDataLoss] marker read failed", err?.message);
  }
  try {
    const tillValue = readTillValue();
    if (tillValue?.cwr_till_id && tables?.tillRegistrations) {
      const registrations = await tables.tillRegistrations.count();
      if (registrations === 0) {
        const tillEvents = tables.tillEvents ? await tables.tillEvents.count() : null;
        const details = { till: tillValue.name ?? null, cwrTillID: tillValue.cwr_till_id, tillEvents };
        logSequenceEvent("till-data-missing", details, sink);
        logTillLifecycle("error", "Till remembered in this browser but its local till data is gone", details);
        written.push("till-data-missing");
      }
    }
  } catch (err) {
    console.warn("[LocalTillDataLoss] till data check failed", err?.message);
  }
  return written;
}
